module.exports = __webpack_public_path__ + "static/media/asset_1.53ee04bd.jpg";